<template>
	<MStateBox :loading="report_detail.loading || !initialized" :empty="isEmpty" class="report-wrap">
		<div class="report-detail-title">{{ detail.title }}</div>
		<div class="info-wrap">
			<div class="date">{{ detail.publishDate | dateFormatYearMonthDate }}</div>
			<div class="author">
				<span>{{ detail.institutionName }}</span> |
				<span>{{ detail.author }}</span>
			</div>
		</div>
		<div v-if="detail.conclusion" v-html="detail.conclusion" class="report-detail-content"></div>
	</MStateBox>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue';
import MStateBox from '@/view/enterprise_rebuild/components/MStateBox.vue';
import { useRoute } from '@/utils/vue-api';
import { useModuleData } from '@/view/enterprise_rebuild/hooks/data/useModuleData';

const { report_detail } = useModuleData();
const route = useRoute();

const detail = ref({});
const initialized = ref(false);
const reportId = ref(route.query.reportId);
const reportType = ref(route.query.reportType);

// 空状态判断
const isEmpty = computed(() => {
	return report_detail.empty || !reportId.value || !detail.value?.conclusion;
});

async function postReportDetail() {
	if (!reportId.value) {
		return;
	}

	await report_detail.refresh({
		reportId: reportId.value,
		reportType: reportType.value
	});

	if (!report_detail.error) {
		// 数据访问路径：根据历史组件，response.data
		let data = report_detail.data?.data;
		detail.value = data || {};
	}
}

onMounted(async () => {
	await postReportDetail();
	initialized.value = true;
});
</script>

<style lang="less" scoped>
.report-wrap {
	padding: 0.12rem 0.14rem;
	font-family: PingFang SC;
	height: 100%;
	overflow-y: auto;
	background: #fff;
	.report-detail-title {
		color: #1d2129;
		font-size: 0.22rem;
		font-weight: 500;
		line-height: 140%; /* 30.8px */
	}
	.info-wrap {
		margin-top: 0.12rem;
		display: flex;
		justify-content: space-between;
		font-size: 0.12rem;
		font-weight: 400;
		line-height: 0.16rem;
		.date {
			color: #a5a5a5;
		}
		.author {
			color: #666;
		}
	}
	.report-detail-content {
		margin-top: 0.16rem;
		font-size: 0.16rem;
		line-height: 200%;
		color: #333333;
		overflow: hidden;
		white-space: pre-wrap;
		font-weight: 400;
	}
	.empty {
		margin-top: 100%;
		transform: translateY(-50%);
	}
}
</style>
